import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CustomSatisfactionInterface, QuestionAnswerInterface } from 'src/app/util/interfaces/customSatisfaction';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CustomSatisfactionRequestService {
	private searchCustomSatisfactionURL = environment.baseApiUrl + 'customSatisfaction';
	private postCustomSatisfactionURL = environment.baseApiUrl + 'customSatisfaction';
	private postQuestionAnswerURL = environment.baseApiUrl + 'customSatisfaction/questionAnswer';
	private updateCustomSatisfactionURL = environment.baseApiUrl + 'customSatisfaction/{id}';
	private deleteCustomSatisfactionURL = environment.baseApiUrl + 'customSatisfaction/{id}';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllCustomSatisfaction(): Observable<CustomSatisfactionInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.httpClient.get<any[]>(this.searchCustomSatisfactionURL, { headers: headers }).pipe(
			map((genericArray: CustomSatisfactionInterface[]) => {
				for (const item of genericArray) {
					item['icon'] = 'faPencil';
					item['formattedOptions'] = this.formatQuestionOptions(item['question_options']);
				}
				return genericArray;
			})
		);
	}

	formatQuestionOptions(questionOptions: any): string {
		let formattedString = '';
		for (const [key, value] of Object.entries(questionOptions)) {
			if (value !== '') {
				formattedString += `Resposta: ${value}, `;
			}
		}
		// Remove a vírgula final
		formattedString = formattedString.replace(/,\s*$/, '');
		return formattedString;
	}

	postCustomSatisfaction(form: CustomSatisfactionInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			question: form.question,
			comment: form.comment,
			question_options: form.question_options,
		};

		return this.httpClient.post(this.postCustomSatisfactionURL, body, { headers: headers });
	}

	updateCustomSatisfaction(formUpdate: CustomSatisfactionInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const updateCustomSatisfactionURL = this.updateCustomSatisfactionURL.replace('{id}', formUpdate.id.toString());
		const body = {
			question: formUpdate.question,
			comment: formUpdate.comment,
			question_options: formUpdate.question_options,
		};

		return this.httpClient.put(updateCustomSatisfactionURL, body, { headers: headers });
	}

	deleteCustomSatisfaction(id: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteCustomSatisfactionURL = this.deleteCustomSatisfactionURL.replace('{id}', id);

		return this.httpClient.delete(deleteCustomSatisfactionURL, { headers: headers });
	}

	postQuestionAnswer(form: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			answer: form.answer,
			comment: form.comment,
			question: form.question,
			request: form.request,
		};

		return this.httpClient.post(this.postQuestionAnswerURL, body, { headers: headers });
	}
}
